export function convertFileList(fileList) {
  return Array.prototype.map.call(fileList, function (file) {
    return {
      name: file.name,
      mimeType: file.type,
      objectUrl: URL.createObjectURL(file)
    };
  });
}